var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.title))]),(!_vm.noCard)?_c('Card',{attrs:{"no-padding":_vm.noPadding}},[_vm._t("default")],2):_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }